{
  "replaceMessage": "Lai aizstātu, nometiet failu"
}
